import React from "react";
import TexCell from "../../../tables/components/atom/TexCell";
import { useNavigate } from "react-router-dom";

const TableRow = ({ request }) => {
  const {
    candidateId,
    applicationId,
    jobId,
    fullName,
    email,
    gender,
    education,
    previousJob,
    status,
  } = request;

  const navigate = useNavigate();

  const goToCandidate = () => {
    navigate(`/jobs/${jobId}/candidates/${candidateId}`, {
      state: { candidateId, applicationId, jobId, fullName },
    });
  };

  return (
    <tr
      className="border-t cursor-pointer hover:bg-gray-50"
      onClick={goToCandidate}
    >
      <TexCell text={candidateId} />
      <TexCell text={fullName} />
      <TexCell text={email} />
      <TexCell text={gender} />
      <TexCell text={education} />
      <TexCell text={previousJob} />
      <TexCell text={status || "shortlisted"} />
    </tr>
  );
};

export default TableRow;
